/*$(function() {
  $('.site-footer li.menu-item-has-children .sub-menu').hide();    
    console.log("Loading footer menu functions");
    // Set height
    $('.site-footer .flickity-viewport').css("transition", "all ease .2s");
    $('.site-footer .flickity-viewport').css("height", "27px");
    
    $('.site-footer .menu > li.menu-item-has-children').click( (event) => {
      event.preventDefault();

        console.log("Clicked!", event.target);
        // Hide all if any open
        $('.site-footer li.menu-item-has-children .sub-menu').slideUp();

        // Make all menu items normal font weight
        $('.site-footer li.menu-item-has-children > a').css("font-weight", "normal");

        // Show footer wrapper if closed
        if ($('.site-footer .flickity-viewport').css("height") == "27px") {
          $('.site-footer .flickity-viewport').css("height", "45px");
        }
         // Show/hide clicked elements submenu
        if ($(event.target).next().hasClass("showing")) {
          $(event.target).next().removeClass("showing");
          $('footer .center').removeClass("open");
          $('.site-footer .flickity-viewport').css("height", "27px");
        } else {
          $(event.target).css("font-weight", "bolder");
          $(event.target).next().addClass("showing");
          $('footer .center').addClass("open");
          $('.site-footer .flickity-viewport').css("height", "45px");
          $(event.target).next().slideDown();
        }

      if ($(event.target).hasClass("childlink") || $(event.target).hasClass("grandchildlink")) {
        window.location.href = $(event.target).attr('href');
      }
    } );

    $(document).scroll(() => {
      if ($('.site-footer .flickity-viewport').css("height") == "45px") {
        $('.site-footer li.menu-item-has-children .sub-menu').slideUp();
        $('.site-footer li.menu-item-has-children > a').css("font-weight", "normal");
        $(".sub-menu.showing").removeClass("showing");
        $('footer .center').removeClass("open");
        $('.site-footer .flickity-viewport').css("height", "27px");
      }
    });
}); */

/**
 * Solution for Flickity carousel not scrolling on mobile devices.
 */
$(document).ready(() => {
  setTimeout(() => {
    const $carousel = $('.main-carousel').flickity();

    $carousel.on('dragStart.flickity', (event, pointer) => {
      document.addEventListener('touchmove', preventScroll, { passive: false });
    });

    $carousel.on('dragEnd.flickity', (event, pointer) => {
      document.removeEventListener('touchmove', preventScroll);
    });
    
    function preventScroll(event) {
      event.preventDefault();
    }
  }, 1000);

  // Show/hide available date, based on seleted variant availability.
  if ($('.available')) {
    $(".swatch-element").click((e) => {
      //console.log("swathc clicked", e.currentTarget, e.currentTarget.classList.contains("soldout"));
      if (e.currentTarget.classList.contains("soldout")) {
        $('.available').show();
      } else {
        $('.available').hide();
      }
    })
  }
});


equalheight = function(container){

var currentTallest = 0,
     currentRowStart = 0,
     rowDivs = new Array(),
     $el,
     topPosition = 0;
 $(container).each(function() {

   $el = $(this);
   $($el).height('auto')
   topPostion = $el.position().top;

   if (currentRowStart != topPostion) {
     for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
       rowDivs[currentDiv].height(currentTallest);
     }
     rowDivs.length = 0; // empty the array
     currentRowStart = topPostion;
     currentTallest = $el.height();
     rowDivs.push($el);
   } else {
     rowDivs.push($el);
     currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
  }
   for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
     rowDivs[currentDiv].height(currentTallest);
   }
 });
}

$(window).load(function() {
  equalheight('.secondary-image');
});


$(window).resize(function(){
  equalheight('.lkljjdjj-img');
});